import { useAppTheme } from "@hooks/useAppTheme";
import {
	type Action,
	KBarAnimator,
	type KBarOptions,
	KBarPortal,
	KBarPositioner,
	KBarProvider,
	useKBar,
} from "kbar";
import { useEffect, useState } from "react";
import type { PropsWithChildren } from "react";
import { TouchableWithoutFeedback, View } from "react-native";
/* -----------------UI--------------- */
import { Surface, TextInput } from "react-native-paper";

/* -----------------Child components--------------- */
import Results from "./Results";

type CommandBarProviderProps = PropsWithChildren<{
	initialActions?: Action[];
	options?: KBarOptions;
}>;

const KBarSearchInput = () => {
	const { query } = useKBar();
	const [localSearch, setLocalSearch] = useState("");

	useEffect(() => {
		query.setSearch("");
		setLocalSearch("");
	}, [query]);

	const handleChangeText = (text: string) => {
		setLocalSearch(text);
		query.setSearch(text);
	};

	return (
		<TextInput
			placeholder="Type a command or search"
			value={localSearch}
			onChangeText={handleChangeText}
			style={{
				backgroundColor: "transparent",
			}}
			autoFocus
		/>
	);
};

export const CommandBarProvider = ({
	children,
	initialActions,
	options,
}: CommandBarProviderProps) => {
	const theme = useAppTheme();

	return (
		<KBarProvider
			actions={initialActions}
			options={{
				disableScrollbarManagement: true,
				enableHistory: true,
				...options,
			}}
		>
			<KBarPortal>
				<TouchableWithoutFeedback>
					<View
						style={{
							position: "absolute",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							backgroundColor: theme.colors.backdrop,
							zIndex: 1300,
						}}
					>
						<KBarPositioner>
							<KBarAnimator style={{ width: "100%", maxWidth: "600px" }}>
								<Surface
									elevation={1}
									style={{
										width: "100%",
										backgroundColor: theme.colors.surface,
									}}
								>
									<KBarSearchInput />
									<Results />
								</Surface>
							</KBarAnimator>
						</KBarPositioner>
					</View>
				</TouchableWithoutFeedback>
			</KBarPortal>
			{children}
		</KBarProvider>
	);
};
